import React, { useMemo, useState } from "react";
import Layout from "../Components/Layout";
import NewsItem from "../Components/NewsItem";
import { news as data } from "../data/Chinese-Zodiac-Horoscope";
import styles from "../styles/NewsItem.module.css";
import inner from "../styles/InnerPage.module.css";
import { Helmet } from "react-helmet-async";
import { useAuth } from "../auth/AuthContext";
import AuthRequiredModal from "../auth/AuthRequiredModal";

export default function News() {
  const news = data;
  const { user, loading } = useAuth();
  const [showAuthGate, setShowAuthGate] = useState(false);

  const isLocked = useMemo(() => !loading && !user, [loading, user]);

  const itemListSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Chinese Zodiac List",
    itemListOrder: "Ascending",
    numberOfItems: news.length,
    itemListElement: news.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.title,
      url: `https://mychinesehoroscope.com/chinese-zodiac/${item.slug}`,
    })),
  };

  return (
    <div>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(itemListSchema)}</script>
      </Helmet>

      <Layout
        title="Chinese Zodiac Finder - My Chinese Horoscope"
        description="Discover all 12 Chinese Zodiac signs and explore their personality traits, birth years, and element influences."
        keywords="Chinese horoscope, zodiac sign, Chinese astrology, Chinese zodiac animals"
        imageUrl="https://mychinesehoroscope.com/my-chinese-horoscope-finder.png"
        schemaType="CollectionPage"
        schemaData={{
          name: "Chinese Zodiac Signs",
          description:
            "Discover all 12 Chinese zodiac signs including their traits, elements, and symbolic meanings.",
          url: "https://mychinesehoroscope.com/chinese-zodiac",
        }}
      >
        {/* ✅ InnerPage layout wrapper */}
        <div className={inner.page}>
          <div className={inner.container}>
            <header className={inner.hero}>
              <p className={inner.kicker}>Chinese Zodiac Finder</p>
              <h1 className={inner.h1}>Discover Your Chinese Zodiac Sign</h1>
              <p className={inner.sub}>
                Your birth year determines your Chinese Zodiac sign. Explore the personality traits,
                birth years, and element influences of all 12 zodiac animals—plus compatibility,
                strengths, and life challenges.
              </p>
            </header>

            {news.length === 0 && <h3>No News</h3>}

            {/* ✅ keep your existing grid */}
            <div className={styles.zodiacGrid}>
              {news.map((item) => (
                <NewsItem
                  key={item.id}
                  news={item}
                  locked={isLocked}
                  onLockedClick={() => setShowAuthGate(true)}
                  className={styles.zodiacItem}
                />
              ))}
            </div>
          </div>
        </div>

        <AuthRequiredModal
          open={showAuthGate}
          onClose={() => setShowAuthGate(false)}
          nextPath="/chinese-zodiac"
          title="Login to read full zodiac details"
          message="Learn more about each zodiac sign’s personality, compatibility, best matches, and challenges. Log in or register to unlock the full details."
        />
      </Layout>
    </div>
  );
}